import { MessageRole, MessageStatus } from "../model/message";

export default function MessageBubble({ message, styles, theme }) {
    const isUser = message.role === MessageRole.USER;
    const isError = message.status === MessageStatus.ERROR;

    return (
        <div
            style={{
                ...styles.message,
                alignSelf: isUser ? "flex-end" : "flex-start",
                background: isUser ? theme.bubbleUser : theme.bubbleBot,
                opacity: isError ? 0.85 : 1,
            }}
        >
            {message.text}
        </div>
    );
}
